import FlowContext from "../context/FlowContext";
import {useContext} from "react";
import Circle from "./Circle";
import BackCircle from "./BackCircle";

const Flow = () => {
    const {centerObj, historyObj, animate} = useContext(FlowContext);

    return (
        <>
            <div className={`flow ${animate ? 'show' : ''} ${!animate ? 'hide' : ''}`}>
                {(historyObj.length > 0) && <BackCircle />}

                {(historyObj.length > 0) && <div className="connector"></div>}

                <div className="circle-box">
                    <div className="circle center-circle">
                        <div className="circle-content">
                            <div className="icon width-40"><img src={'\'assets/images/\' + centerObj?.img'} alt=""/>
                            </div>
                            <div className="name font-18">{centerObj?.name}</div>
                        </div>
                    </div>
                    <ul className="children">
                        {centerObj.children.map((circle, index) =>
                            <Circle key={circle.id} circle={circle} index={index}/>
                        )}
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Flow;
